(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("moment"), require("pikaday"), require("numbro"), require("hot-formula-parser"));
	else if(typeof define === 'function' && define.amd)
		define("Handsontable", ["moment", "pikaday", "numbro", "hot-formula-parser"], factory);
	else if(typeof exports === 'object')
		exports["Handsontable"] = factory(require("moment"), require("pikaday"), require("numbro"), require("hot-formula-parser"));
	else
		root["Handsontable"] = factory(root["moment"], root["Pikaday"], root["numbro"], root["formulaParser"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_42__, __WEBPACK_EXTERNAL_MODULE_402__, __WEBPACK_EXTERNAL_MODULE_413__, __WEBPACK_EXTERNAL_MODULE_88__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition